import ReactGA from "react-ga4";
import type { MarketingReporter } from "./marketingEvents";

const EVENTS = new Set(["public_page_view", "product_cta_impression", "product_cta_clicked"]);
type GaClient = { initialize(id: string, options: { gtagOptions: { send_page_view: false } }): void; event(name: string, parameters: Record<string, unknown>): void };

export function createMarketingGa4Reporter({
  measurementId,
  ga = ReactGA as unknown as GaClient,
}: { measurementId: string; ga?: GaClient }): MarketingReporter {
  let initialized = false;
  return (event, parameters) => {
    if (!/^G-[A-Z0-9]{4,}$/.test(measurementId) || !EVENTS.has(event) || parameters.consentState !== "granted") return;
    if (!initialized) {
      ga.initialize(measurementId, { gtagOptions: { send_page_view: false } });
      initialized = true;
    }
    ga.event(event, parameters);
  };
}

export const marketingGa4Reporter = createMarketingGa4Reporter({
  measurementId: import.meta.env.VITE_GA_MEASUREMENT_ID ?? "",
});
